module.exports = __webpack_public_path__ + "static/media/air-freshener.4d323aef.svg";